<template>
    <v-dialog v-model="showDialog" width="500">
        <template v-slot:activator="{ on, attrs }">
            <v-btn x-small class="mt-0 ml-2 white--text" color="red darken-4" :disabled="disabled" v-bind="attrs"
                v-on="on">
                {{mutation}}
            </v-btn>
        </template>
        <v-card-title class="text-h5 grey lighten-2">
            Are you sure to {{mutation}} this {{type}}?
        </v-card-title>
        <v-card>

            <v-card-text v-if="(item.first_name && item.last_name)" v-html="item.first_name + ' ' + item.last_name">
            </v-card-text>
            <v-card-text v-else v-html="item.title ? item.title : item.name">
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="showDialog = false">
                    Cancel
                </v-btn>
                <v-btn color="primary" @click="mutateItem">
                    {{mutation}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import router from '../../router';
export default {
    props: {
        item: {
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        mutation: {
            type: String,
            default: "mutate"
        },
        mutationEndpoint: {
            type: String,
            default: null

        }, type: {
            type: String,
            default: "item"
        }
    },
    data() {
        return {
            showDialog: false,
            notifications: false,
            sound: true,
            widgets: false,
        }
    },
    watch: {
        showDialog(newVal, oldVal) {
            if (!oldVal && newVal) {
                this.$emit("onMutateRequest", this.item);
            } else if (!newVal && oldVal) {
                this.$emit("onMutateFinish", this.item);
            }
        }
    },
    methods: {
        mutateItem() {
            var that = this;
            var nameRoute = this.$route.name;
            axios.post(this.mutationEndpoint + this.item.id, {}).then(function (response) {
                that.showDialog = false;
                that.$emit("onMutateSuccess", that.item);
                if(nameRoute == 'news.bo'){
                    router.push({name:'news.reorder.bo'});
                }
                else if(nameRoute == 'postdocs.bo' || nameRoute == 'researchers.bo'){
                    router.push({name:'former.bo'});
                }
                else if( nameRoute == 'staff.bo'){        
                    router.push({name:'staff.bo'});
                }
                else{
                    router.push({name:'dashboardlist'});
                }
            }).catch(() => {
                console.error("Failed to " + that.mutation + " item.");
                that.$emit("onMutateFailed", that.item);
            });
        },
    },
}
</script>
